import React, { useState, useEffect, useContext } from "react";
import MainContainer from "../../components/MainContainer";
import MainHeader from "../../components/MainHeader";
import Title from "../../components/Title";
import MainHeaderButtonsWrapper from "../../components/MainHeaderButtonsWrapper";
import { Button, Paper } from "@mui/material";
import { makeStyles } from 'tss-react/mui';
import { Grid } from "@mui/material";
import QuickMessagesTable from "../../components/QuickMessagesTable";
import QuickMessageDialog from "../../components/QuickMessageDialog";
import ConfirmationModal from "../../components/ConfirmationModal";

import { i18n } from "../../translate/i18n";
import { toast } from "../../services/toast";

import useQuickMessages from "../../hooks/useQuickMessages";
import { AuthContext } from "../../context/Auth/AuthContext";
import QueueSelectUnit from "../../components/QueueSelectUnit";


import SearchIcon from "@mui/icons-material/Search";
import TextField from "@mui/material/TextField";

import InputAdornment from "@mui/material/InputAdornment";



const useStyles = makeStyles()((theme) => ({
  mainPaper: {
    flex: 1,
    padding: theme.spacing(1),
    overflowY: "scroll",
    ...theme.scrollbarStyles,
  },
}));

function QuickMessages(props) {
  const { classes } = useStyles();
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [messageSelected, setMessageSelected] = useState({});
  const [showOnDeleteDialog, setShowOnDeleteDialog] = useState(false);
  const [selectedQueueIds, setSelectedQueueIds] = useState(0);
  const [searchParam, setSearchParam] = useState("");
  const [filteredData, setFilteredData] = useState([]);

  const {
    list: listMessages,
    save: saveMessage,
    update: updateMessage,
    deleteRecord: deleteMessage,
  } = useQuickMessages();

  const { user } = useContext(AuthContext);

  useEffect(() => {
    const fetchData = async () => {
      await loadingQuickMessages();
    };
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const Filtrer = async (value) => {
    setSelectedQueueIds(value);

    if (value == '') {
      setFilteredData(messages);
    } else {
      const filtered = messages.filter(item => item.departamentid == value);
      setFilteredData(filtered);
    }
  }
  const loadingQuickMessages = async () => {
    setLoading(true);
    try {
      const companyId = localStorage.getItem("companyId");
      const messages = await listMessages({ companyId, userId: user.id });
      setMessages(messages);
      setFilteredData(messages);
    } catch (e) {
      toast.error(e);
    }
    setLoading(false);
  };

  const handleOpenToAdd = () => {
    setModalOpen(true);
  };

  const handleOpenToEdit = (message) => {
    setMessageSelected(message);
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
    setMessageSelected({ id: null, message: "", shortcode: "" });
  };

  const handleSave = async (message) => {
    handleCloseModal();
    try {
      await saveMessage(message);
      await loadingQuickMessages();
      toast.success("Mensaje agregado con éxito.");
    } catch (e) {
      toast.error(e);
    }
  };
  const Refresh = async () => {
    handleCloseModal();
    try {
      await loadingQuickMessages();
      toast.success("Mensaje agregado con éxito.");
    } catch (e) {
      toast.error(e);
    }
  };

  const handleEdit = async (message) => {
    handleCloseModal();
    try {
      await updateMessage(message);
      await loadingQuickMessages();
      toast.success("Mensaje actualizado con éxito.");
    } catch (e) {
      toast.error(e);
    }
  };

  const handleDelete = async (message) => {
    handleCloseModal();

    if (user.profile == "user") return toast.error("Solo un administrador o supervisor puede eliminar los registros!");

    try {
      await deleteMessage(message.id);
      await loadingQuickMessages();
      toast.success("Mensaje eliminado con éxito.");
    } catch (e) {
      toast.error(e);
    }
  };

  const handleSearch = (event) => {
    const value = event.target.value.toLowerCase();
    setSearchParam(value);
    const filtered = messages.filter(item => item.shortcode.toLowerCase().includes(value));
    setFilteredData(filtered);

  };



  return (
    <MainContainer maxWidth={false}>
      <MainHeader>
        <Grid container spacing={2} sx={{
          alignItems: "center"
        }}>

          <Grid
            size={{
              xs: 12,
              sm: 5
            }}>
            <Title>{i18n.t("quickMessages.title")}</Title>
          </Grid>


          <Grid
            size={{
              xs: 12,
              sm: 3,
              md: 3
            }}>
            <QueueSelectUnit
              selectedQueueIds={selectedQueueIds}
              onChange={(values) => Filtrer(values)}
              fullWidth
            />
          </Grid>

          <Grid
            size={{
              xs: 12,
              sm: 3,
              md: 2
            }}>
            <TextField
              placeholder={"Buscar"}
              type="search"
              size="small"
              value={searchParam}
              onChange={handleSearch}
              fullWidth
              slotProps={{
                input: {
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon style={{ color: "gray" }} />
                    </InputAdornment>
                  ),
                }
              }}
            />
          </Grid>

          <Grid
            size={{
              xs: 12,
              sm: 4,
              md: 2
            }}>
            <MainHeaderButtonsWrapper>
              <Button
                variant="contained"
                color="primary"
                onClick={handleOpenToAdd}
                fullWidth
              >
                {i18n.t("quickMessages.buttons.add")}
              </Button>
            </MainHeaderButtonsWrapper>
          </Grid>
        </Grid>
      </MainHeader>
      <Paper className={classes.mainPaper} variant="outlined">
        <QuickMessagesTable
          readOnly={false}
          messages={filteredData}
          showLoading={loading}
          editMessage={handleOpenToEdit}
          deleteMessage={(message) => {
            setMessageSelected(message);
            setShowOnDeleteDialog(true);
          }}
        />
      </Paper>
      <QuickMessageDialog
        messageSelected={messageSelected}
        modalOpen={modalOpen}
        onClose={handleCloseModal}
        editMessage={handleEdit}
        saveMessage={handleSave}
        refresh={Refresh}
      />
      <ConfirmationModal
        title="Eliminar Registro"
        open={showOnDeleteDialog}
        onClose={setShowOnDeleteDialog}
        onConfirm={async () => {
          await handleDelete(messageSelected);
        }}
      >
        ¿Realmente desea eliminar este registro?
      </ConfirmationModal>
    </MainContainer>
  );
}

export default QuickMessages;
